/* ============================================================
   Maison Sillage · theme JS
   Age gate, mobiel menu, variant-keuze, add-ons.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Age gate (1× per sessie) ---------- */
  function initGate() {
    var gate = document.getElementById("gate");
    if (!gate) return;
    var ok = false;
    try { ok = sessionStorage.getItem("os_age_ok") === "1"; } catch (e) {}
    if (ok) { gate.classList.add("gate-hidden"); return; }
    var yes = gate.querySelector("[data-gate-yes]");
    if (yes) yes.addEventListener("click", function () {
      try { sessionStorage.setItem("os_age_ok", "1"); } catch (e) {}
      gate.classList.add("gate-hidden");
    });
  }

  /* ---------- Mobiel menu ---------- */
  function initMenu() {
    var t = document.querySelector(".menu-toggle");
    var nav = document.querySelector("header.site nav");
    if (t && nav) t.addEventListener("click", function () { nav.classList.toggle("open"); });
  }

  /* ---------- Productformulier: varianten + add-ons ---------- */
  function initProductForm() {
    var root = document.querySelector("[data-product-form]");
    if (!root) return;

    var variants = [];
    var dataEl = root.querySelector("[data-variant-json]");
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var idInput   = root.querySelector("[data-variant-id]");
    var priceEl   = document.querySelector("[data-price-display]");
    var addBtn    = root.querySelector("[data-add-btn]");
    var badgeEl   = document.querySelector("[data-wear-badge]");
    var money     = root.getAttribute("data-money-format") || "€ {{amount}}";

    function fmt(cents) {
      var v = (cents / 100).toFixed(2).replace(".", ",");
      return money.replace(/\{\{\s*amount\s*\}\}/, v);
    }

    function currentVariant() {
      var sel = root.querySelector(".opt.sel[data-variant]");
      if (sel) {
        var vid = sel.getAttribute("data-variant");
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(vid)) return variants[i];
        }
      }
      return variants[0];
    }

    function checkedAddons() {
      return Array.prototype.slice.call(root.querySelectorAll("[data-addon]:checked"));
    }

    function addonTotal() {
      return checkedAddons().reduce(function (t, cb) {
        return t + (parseInt(cb.getAttribute("data-addon-price"), 10) || 0);
      }, 0);
    }

    function refresh() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var total = v.price + addonTotal();
      if (priceEl) priceEl.textContent = fmt(total);
      if (badgeEl && v.title) badgeEl.textContent = v.title;
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = addBtn.getAttribute("data-label-add") || "In tas";
        } else {
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = addBtn.getAttribute("data-label-sold") || "Verkocht";
        }
      }
    }

    root.querySelectorAll(".opt[data-variant]").forEach(function (o) {
      o.addEventListener("click", function () {
        root.querySelectorAll(".opt[data-variant]").forEach(function (x) { x.classList.remove("sel"); });
        o.classList.add("sel");
        refresh();
      });
    });
    root.querySelectorAll("[data-addon]").forEach(function (cb) {
      cb.addEventListener("change", refresh);
    });

    /* MTO: visuele verkoopster-keuze → hidden input dat de submit-handler leest. */
    var vkInput = root.querySelector("[data-mto-verkoopster]");
    var vkCards = root.querySelectorAll(".vk-card[data-verkoopster]");
    if (vkInput && vkCards.length) {
      var selectVk = function (card) {
        vkCards.forEach(function (c) { c.classList.remove("sel"); });
        card.classList.add("sel");
        vkInput.value = card.getAttribute("data-verkoopster") || "";
      };
      selectVk(vkCards[0]);                                   // default: eerste opt-in verkoopster
      vkCards.forEach(function (card) {
        card.addEventListener("click", function () { selectVk(card); });
      });
    }

    /* Bestellen: hoofdartikel + aangevinkte extra's in één keer toevoegen.
       Extra's zijn losse producten, want line item properties kunnen de prijs
       niet verhogen. Valt terug op een gewone formulierverzending bij een fout. */
    var form = root.closest("form");
    if (form) {
      var isMto = root.hasAttribute("data-mto");
      form.addEventListener("submit", function (e) {
        var addons = checkedAddons();
        // Pre-worn zonder extra's → normale Shopify-afhandeling. MTO onderschept altijd (properties).
        if (!isMto && !addons.length) return;
        e.preventDefault();

        var v = currentVariant();
        if (!v) { form.submit(); return; }

        // Payload-bouw is één pure functie (cart-payload.js) zodat 'ie los te testen is.
        var build = window.OS && window.OS.buildCartPayload;
        if (!build) { form.submit(); return; }

        var selection = { type: isMto ? "mto" : "pre-worn", variantId: v.id, addons: [] };
        addons.forEach(function (cb) {
          var vid = cb.getAttribute("data-addon-variant");
          if (vid) selection.addons.push(parseInt(vid, 10));
        });
        if (isMto) {
          var vk = root.querySelector("[data-mto-verkoopster]");
          var tp = root.querySelector("[data-mto-type]");
          var mt = root.querySelector("[data-mto-maat]");
          var kled = [tp && tp.value, mt && mt.value].filter(Boolean).join(" · ");
          selection.mto = { verkoopster: vk ? vk.value : "", draagtijd: v.title || "", kledingstuk: kled };
        }
        var payload = build(selection);

        if (addBtn) { addBtn.setAttribute("disabled", "disabled"); addBtn.textContent = "Bezig…"; }

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            if (!r.ok) throw new Error("cart/add mislukt");
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart";
          })
          .catch(function () {
            if (addBtn) addBtn.removeAttribute("disabled");
            form.submit();                     // fallback: zonder extra's toevoegen
          });
      });
    }

    refresh();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initGate();
    initMenu();
    initProductForm();
  });
})();
